import React, { useState, useEffect, useRef, useCallback } from 'react';
import ButtonGroupItem from "./ButtonGroupItem";
import VehicleFormFields from "./VehicleFormFields";
import { ButtonGroup, ContentFooter, ContentWrapper, ContentWrapperInner } from "../layout/Wrapper";
import { fetch, omit, redirectTo, highlightFirstError } from "../../modules/utils";
const VehicleForm = ({ resourceName = 'api_person_vehicle', resource, authenticityToken, referrer, onAfterSubmit, onCancel, onChange = () => { }, onSubmit, locked = false, endedAtLocked = false, includeWrapper = true }) => {
    const [vehicle, setVehicle] = useState(null);
    const [action, setAction] = useState('new');
    const [errors, setErrors] = useState({});
    const [disabled, setDisabled] = useState(endedAtLocked);
    const [flash, setFlash] = useState(false);
    const [flashType, setFlashType] = useState('info');
    const [unchangedVehicle, setUnchangedVehicle] = useState(null);
    const regInputRef = useRef(null);
    useEffect(() => { if (locked) {
        const flashMessage = endedAtLocked ? 'You cannot update this vehicle' : "You can only update the <strong>'Until date'</strong> on this vehicle";
        setFlash(flashMessage + ' because it has been used in one of your previous claim submissions. Please <a data-trigger-modal="contact-modal" href="">contact us</a> if you need anything else corrected.</p>');
    } }, [locked, endedAtLocked]);
    useEffect(() => { if (resource && resource !== unchangedVehicle) {
        const addedValues = { owned: !Boolean(resource.ended_at), company_car: resource.company_car || false, registration: resource.registration || '', kind: resource.kind || '', make: resource.make || '', model: resource.model || '' };
        setVehicle({ ...resource, ...addedValues });
        setUnchangedVehicle(resource);
        setAction(resource.id ? 'edit' : 'new');
    } }, [resource, unchangedVehicle]);
    const handlePropagation = useCallback((name, value, owned) => { setDisabled(false); setErrors(prevErrors => omit(prevErrors, [name])); if (name !== 'registration') {
        setVehicle(prevVehicle => { const stateUpdates = { [name]: value }; if (owned !== undefined) {
            stateUpdates['owned'] = owned;
        } return { ...prevVehicle, ...stateUpdates }; });
    } onChange(); }, [onChange]);
    const updateVehicleData = useCallback(selectedVehicle => { setDisabled(false); setVehicle(prevVehicle => ({ ...prevVehicle, ...selectedVehicle })); setErrors(prevErrors => omit(prevErrors, Object.keys(selectedVehicle))); onChange(); }, [onChange]);
    const handleSubmit = useCallback(e => {
        e.preventDefault(); // If parent component wants to handle submission, call their handler and return
        if (onSubmit) {
            const vehicleData = { ...vehicle }; // Get registration value from lookup if not set
            if (!vehicleData.registration && regInputRef.current) {
                const regValue = regInputRef.current.value;
                vehicleData.registration = regValue;
            }
            onSubmit(vehicleData, (submitErrors, submitFlash, submitFlashType) => { if (submitErrors) {
                setErrors(submitErrors);
                setDisabled(false);
                highlightFirstError();
            }
            else {
                setDisabled(false);
            } if (submitFlash) {
                setFlash(submitFlash);
                setFlashType(submitFlashType || 'failure');
            } });
            return;
        } // Otherwise handle submission internally
        setDisabled(true);
        let method = 'POST';
        let path = '/vehicles';
        const formData = { api_person_vehicle: vehicle, utf8: '✓', authenticity_token: authenticityToken };
        if (action === 'edit') {
            path = path + '/' + vehicle.id;
            method = 'PATCH';
        }
        if (!formData.api_person_vehicle.registration && regInputRef.current) {
            const regValue = regInputRef.current.value;
            formData.api_person_vehicle.registration = regValue;
        }
        fetch(method, path, 'application/json', 'application/json', formData).then(data => { if (referrer) {
            redirectTo(referrer);
        }
        else if (onAfterSubmit) {
            onAfterSubmit(data);
        }
        else {
            setVehicle(null);
        } }).catch(errResponse => { const data = errResponse[1]; console.error(JSON.stringify(data.errors)); setErrors(data.errors || {}); if (data.flash) {
            setFlash(data.flash);
            setFlashType(data.flashType || 'failure');
        } setDisabled(false); highlightFirstError(); });
    }, [onSubmit, vehicle, action, authenticityToken, referrer, onAfterSubmit]);
    if (!vehicle) {
        return null;
    }
    const renderFields = () => /*#__PURE__*/ React.createElement(VehicleFormFields, { resourceName: resourceName, vehicle: vehicle, errors: errors, flash: flash, flashType: flashType, locked: locked, endedAtLocked: endedAtLocked, handlePropagation: handlePropagation, updateVehicleData: updateVehicleData, ref: regInputRef });
    if (!includeWrapper) {
        return renderFields();
    }
    return /*#__PURE__*/ React.createElement(ContentWrapper, { modifiers: "small" }, /*#__PURE__*/ React.createElement(ContentWrapperInner, { modifiers: "longform" }, renderFields()), /*#__PURE__*/ React.createElement(ContentFooter, { modifiers: "actions" }, /*#__PURE__*/ React.createElement(ButtonGroup, { modifiers: "spread" }, /*#__PURE__*/ React.createElement(ButtonGroupItem, { buttonModifiers: "back-link", element: "anchor", href: referrer || '#', onClick: onCancel, disabled: false }, "Cancel"), /*#__PURE__*/ React.createElement(ButtonGroupItem, { buttonModifiers: "primary", element: "button", disabled: disabled, onClick: handleSubmit }, "Save vehicle"))));
};
export default VehicleForm;
